const n = () => {
  const t = /* @__PURE__ */ new Map();
  return {
    getItem(e) {
      return t.get(e) ?? null;
    },
    setItem(e, r) {
      t.set(e, r);
    },
    removeItem(e) {
      t.delete(e);
    }
  };
};
export {
  n as createInMemoryStorage
};
//# sourceMappingURL=in-memory.js.map
